export const pendoTags = {
  contactPanel: {
    downloadPdf: 'app-forms-contact-panel-download-pdf',
    preview: 'app-forms-contact-panel-preview',
    sent: 'app-forms-contact-panel-sent',
    submissions: 'app-forms-contact-panel-submissions',
    sendForm: 'app-forms-contact-panel-send-form',
  },
};
